import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/auth-context'
import { PendingApprovalScreen } from '../features/onboarding/pending-approval-screen'
import {
  OnCallReminderBanner,
  useOnCallReminders,
} from '../features/on-call/hooks/use-on-call-reminders'

function OnCallReminderHost() {
  const { reminder, dismissReminder } = useOnCallReminders()
  if (!reminder) return null
  return <OnCallReminderBanner reminder={reminder} onDismiss={dismissReminder} />
}

export function ProtectedRoute() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <div style={{ padding: 48, textAlign: 'center' }}>Loading…</div>
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />
  }

  // Invited members await Provider Owner (L4) approval before full app access.
  if (user.status === 'PENDING_INVITE') {
    return <PendingApprovalScreen />
  }

  return (
    <>
      <OnCallReminderHost />
      <Outlet />
    </>
  )
}
